import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import resizeImageUrl from '@afosto/utils/resizeImageUrl';
import { arrayLengthFormatter } from '../formatters';
import ShipmentFormatter from '@afosto/utils-react/formatters/ShipmentFormatter';
import styled from 'styled-components';
import translations from './translations';

const StyledOverline = styled(Typography)`
  && {
    line-height: 1;
  }
`;

const HandlingListItem = ({ item, isOutbound }) => {
  const intl = useIntl();

  return (
    <Grid key={item.id} item xs={12}>
      <Card>
        <Box display="flex" flexWrap="nowrap" alignItems="center">
          <Box flexGrow={1}>
            <CardContent>
              <List disablePadding>
                <ListItem disableGutters>
                  <ListItemAvatar>
                    <Avatar src={item?.product && resizeImageUrl(item?.product?.image, 50)} />
                  </ListItemAvatar>
                  <ListItemText primary={item.description} secondary={item.sku} />
                </ListItem>
              </List>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Box mt={2}>
                    <Box pb={0.5}>
                      <StyledOverline variant="overline" color="textSecondary">
                        <FormattedMessage {...translations.properties.position} />
                      </StyledOverline>
                    </Box>
                    <Typography variant="body2">{item?.position || '-'}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box mt={2}>
                    <Box pb={0.5}>
                      <StyledOverline variant="overline" color="textSecondary">
                        <FormattedMessage {...translations.properties.shipment} />
                      </StyledOverline>
                    </Box>
                    <Typography variant="body2">
                      <ShipmentFormatter shipmentId={item?.shipment_id} showAsLink={false} />
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              {item?.sorting_label && (
                <Box mt={2}>
                  <Box pb={0.5}>
                    <StyledOverline variant="overline" color="textSecondary">
                      <FormattedMessage {...translations.properties.crate} />
                    </StyledOverline>
                  </Box>
                  <Typography variant="body2">{item?.sorting_label ?? '-'}</Typography>
                </Box>
              )}
              <Box mt={2}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant="overline" color="textSecondary">
                      {intl.formatMessage({
                        id: 'dataGrid.columns.handlingListItems.quantity',
                        defaultMessage: 'Quantity',
                        description: 'The column name for column quantity',
                      })}
                    </Typography>
                    <Typography variant="body2" color="textPrimary">
                      {item.quantity}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="overline" color="textSecondary">
                      {intl.formatMessage({
                        id: `dataGrid.columns.handlingListItems.${
                          isOutbound ? 'picked' : 'placed'
                        }`,
                        defaultMessage: isOutbound ? 'Picked' : 'Placed',
                        description: 'The column name for column handled',
                      })}
                    </Typography>
                    <Typography variant="body2" color="textPrimary">
                      {arrayLengthFormatter(item.handled_ids)}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

HandlingListItem.propTypes = {
  isOutbound: PropTypes.bool,
  item: PropTypes.object.isRequired,
};

HandlingListItem.defaultProps = {
  isOutbound: false,
};

export default HandlingListItem;
